import { Loader } from '@mantine/core';

export default function IconCircleLoadingAnimated({ size, color }: { size: number; color: string }) {
  const loaderSize = size * 0.8;
  const paddingSize = (size * 0.2) / 2;
  return (
    <Loader
      style={{ padding: paddingSize }}
      className="flex-shrink-0"
      // className={`p-[${paddingSize}px]`}
      color={color}
      size={loaderSize}
    />
  );
}
